import { postStoryWords, type StoryWord } from '../api/storiesApi';

/** Сколько слов сервер принимает за раз (`STORY_WORDS_MAX`). */
const BATCH = 20;

/**
 * Мост к словарю: слова из игры ложатся ручными карточками (без жетонов) в модуль `moduleName` («Выживи в Лондоне»),
 * который создаётся при первом сохранении. Им пользуются итоги игры и слова из демо после регистрации.
 * С 2026-10-30 — одним запросом на сервер (POST /cards/story-words): без подтверждённой почты, слово уже в модуле
 * пропускается, повтор не задваивает. Раньше карточки шли по одной, и первая ошибка (слово уже сохранено прошлым
 * оборвавшимся запросом) навсегда оставляла остальные несохранёнными (приёмка 2026-10-30).
 */
export async function saveStoryWords(words: StoryWord[], moduleName: string): Promise<{ moduleId: string; moduleName: string }> {
  let result: { moduleId: string; moduleName: string } | null = null;
  for (let i = 0; i < words.length; i += BATCH) {
    const res = await postStoryWords(words.slice(i, i + BATCH), moduleName);
    result = { moduleId: res.module_id, moduleName: res.module_name };
  }
  if (!result) throw new Error('No story words to save');
  return result;
}
